import React from "react";
import CSS from "react-css-modules";
import Fade from "react-reveal/Fade";

import Header from "app/components/common/Header";

import backgroundStudio from "assets/images/background_studio2.jpg";
import appleIconBlack from "assets/images/apple.png";
import windowIcon from "assets/images/window.png";
import pdfIcon from "assets/images/ic_pdf.png";

import styles from "./style.scss";

class Studio extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      studioVersion: "1.0.1",
    };
  }

  componentWillMount() {
    const xhr = new XMLHttpRequest();
    xhr.open(
      "GET",
      "https://s3.amazonaws.com/studio.global.chatie.me/releases/latest.yml"
    );
    xhr.onload = () => {
      const regex = /(\d+\.)(\d+\.)(\d)/;
      this.setState({
        studioVersion: xhr.responseText.match(regex)[0],
      });
    };
    xhr.setRequestHeader("Access-Control-Allow-Headers", "*");
    xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
    xhr.send();
  }

  render() {
    const { studioVersion } = this.state;
    return (
      <React.Fragment>
        <Header />
        <div styleName="studio">
          <div
            styleName="studio__main"
            style={{
              backgroundImage: `url(${backgroundStudio})`,
            }}
          >
            <Fade>
              <div styleName="studio__main__contents">
                <h4>Tell your story with</h4>
                <h4>Chatie Studio</h4>
                <p>
                  Create a your story with a professional and versatile PC
                  studio
                </p>
                <a
                  href={`https://s3.amazonaws.com/studio.global.chatie.me/releases/ChatieStudio-${studioVersion}-universal.dmg`}
                  download
                >
                  <button
                    type="button"
                    styleName="studio__main__contents__studio-download"
                  >
                    <img src={appleIconBlack} alt="Apple" />
                    <span>Download for MAC</span>
                  </button>
                </a>
                <a
                  href={`https://s3.amazonaws.com/studio.global.chatie.me/releases/ChatieStudio+Setup+${studioVersion}.exe`}
                  download
                >
                  <button
                    type="button"
                    styleName="studio__main__contents__studio-download"
                  >
                    <img src={windowIcon} alt="Windows" />
                    <span>Download for Window</span>
                  </button>
                </a>
                <a
                  download
                  href="https://cdn.efinder.global.chatie.me/misc/studio-pc/Chatie+Studio+Guide+Eng_Ver.+2.10.5.pdf"
                >
                  <button
                    type="button"
                    styleName="studio__main__contents__studio-download"
                  >
                    <img src={pdfIcon} alt="pdf" />
                    <span>Download Guide</span>
                  </button>
                </a>
              </div>
            </Fade>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const Component = CSS(Studio, styles, { allowMultiple: true });

export default Component;



// WEBPACK FOOTER //
// ./src/app/pages/Studio/index.js